"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeType = exports.assetTypeToString = exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType[AssetType["Image"] = 1] = "Image";
    AssetType[AssetType["Video"] = 2] = "Video";
    AssetType[AssetType["Url"] = 3] = "Url";
    AssetType[AssetType["Document"] = 4] = "Document";
    AssetType[AssetType["Audio"] = 5] = "Audio";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
exports.assetTypeToString = function (type) {
    switch (type) {
        case AssetType.Image: return 'Image';
        case AssetType.Video: return 'Video';
        case AssetType.Url: return 'Url';
        case AssetType.Document: return 'Document';
        case AssetType.Audio: return 'Audio';
    }
};
var SizeType;
(function (SizeType) {
    SizeType[SizeType["None"] = 0] = "None";
    SizeType[SizeType["Small"] = 1] = "Small";
    SizeType[SizeType["Medium"] = 2] = "Medium";
    SizeType[SizeType["Large"] = 3] = "Large";
    SizeType[SizeType["ExtraLarge"] = 4] = "ExtraLarge";
    SizeType[SizeType["Thumbnail"] = 5] = "Thumbnail";
})(SizeType = exports.SizeType || (exports.SizeType = {}));
